<template>
  <div class="p-12">
    <div v-if="loading" class="text-center">
      <Loader />
    </div>
    <div v-else-if="facebookPagesWithLinkedInstagramAccount.length">
      <BaseFormSelect
        v-if="facebookPagesWithLinkedInstagramAccount.length > 1"
        v-model="selectedFacebookPageId"
        :options="facebookPageOptions"
      />
      <div v-if="selectedFacebookPageId" class="mt-6">
        <Insights
          :key="selectedFacebookPageId"
          :facebook-page-id="selectedFacebookPageId"
          :account-id="accountId"
        />
      </div>
    </div>
    <div v-else class="rounded-md bg-yellow-50 p-4 max-w-lg mx-auto">
      <div class="flex">
        <div class="flex-shrink-0">
          <!-- Heroicon name: solid/exclamation -->
          <svg
            class="h-5 w-5 text-yellow-400"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="ml-3">
          <h3 class="text-sm font-medium text-yellow-800">
            There are no Instagram Accounts currently linked to your Facebook Pages.
          </h3>
          <div class="mt-2 text-sm text-yellow-700">
            <p>Link your Instagram account to your facebook page in order to receive insights.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Insights from './instagram/components/insights.vue';

export default {
  components: {
    Insights,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      selectedFacebookPageId: null,
    };
  },
  computed: {
    facebookPageIds() {
      return this.$store.getters['ui/accountFacebookPages/idsByParent'](this.accountId);
    },
    facebookPages() {
      return this.facebookPageIds.map((id) => this.$store.state.entities.facebookPages.byId[id]);
    },
    facebookPagesWithLinkedInstagramAccount() {
      return this.facebookPages.filter(
        (facebookPage) => typeof facebookPage.instagramBusinessAccountId === 'string'
      );
    },
    facebookPageOptions() {
      return this.facebookPagesWithLinkedInstagramAccount.map((facebookPage) => ({
        label: facebookPage.name,
        value: facebookPage.id,
      }));
    },
  },
  created() {
    this.fetchAccountFacebookPages();
  },
  destroyed() {
    this.$store.dispatch('ui/accountFacebookPages/clearIds', this.accountId);
  },
  methods: {
    async fetchAccountFacebookPages() {
      try {
        this.loading = true;
        await this.$store.dispatch('ui/accountFacebookPages/load', {
          parentId: this.accountId,
        });

        const [defaultFacebookPage = null] = this.facebookPagesWithLinkedInstagramAccount;
        this.selectedFacebookPageId = defaultFacebookPage?.id || null;
      } catch (error) {
        // catch any server errors here
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
